exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".photos-container img {\r\n  width: 200px;margin: 0 10px;\r\n}\r\n.photos-container {\r\n  padding: 20px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Web/Dubai/code/kapil/DubairentV3/cpapi/CPDubairentApp/CPDubairentApp/src/app/propertiesManagement/property/set-property-photo/set-property-photo.component.css
// module id = ../../../../../src/app/propertiesManagement/property/set-property-photo/set-property-photo.component.css
// module chunks = main